export var NATIVE_RPC_METHODS;
(function (NATIVE_RPC_METHODS) {
    NATIVE_RPC_METHODS["FIREBASE_GET_TOKEN"] = "tokensModule:getFCM";
    NATIVE_RPC_METHODS["GET_ACCESS_TOKEN"] = "tokensModule:getAccess";
    NATIVE_RPC_METHODS["GET_REFRESH_TOKEN"] = "tokensModule:getRefresh";
    NATIVE_RPC_METHODS["AUTHORIZE"] = "tokensModule:authorize";
    NATIVE_RPC_METHODS["REFRESH_TOKENS"] = "tokensModule:refreshTokens";
})(NATIVE_RPC_METHODS || (NATIVE_RPC_METHODS = {}));
export var NATIVE_RPC_EVENTS;
(function (NATIVE_RPC_EVENTS) {
    NATIVE_RPC_EVENTS["FIREBASE_UPDATE_TOKEN_EVENT"] = "newFCMTokenReceived";
    NATIVE_RPC_EVENTS["ACCESS_TOKEN_UPDATE_EVENT"] = "newAccessTokenReceived";
    NATIVE_RPC_EVENTS["NOTIFICATION_RECEIVED_EVENT"] = "onNewNotificationReceived";
    NATIVE_RPC_EVENTS["NOTIFICATION_OPENED_EVENT"] = "onNewNotificationOpened";
})(NATIVE_RPC_EVENTS || (NATIVE_RPC_EVENTS = {}));
